import { useAuth } from '@workos-inc/authkit-react';
import { useEffect } from 'react';

/**
 * This component is used to trigger the login process.
 * If a user bookmarks the hosted login page, they will be redirect here to trigger the login process.
 * @returns null
 */
export function Login() {
  const { signIn } = useAuth();

  useEffect(() => {
    signIn();
  }, [signIn]);

  return null;
}
